import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D1() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    return (
        <div id="vanlife-roadtrips-D" className={`vanlife-roadtrips-D1 ${css['vanlife-roadtrips-D1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786095262205-9tndze-compressed-003.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786095317839-wcmjlq-compressed-003.webp"
                alt={t('secD_title')}
                aria-label={t('secD_title')}
            />
            <div className="info">
                <p className="title">{t('secD_title')}</p>
                <p className="desc">{t('secD_desc')}</p>
            </div>
        </div>
    );
}
